import { useQuery } from '@apollo/client'

import { MyMe_UserFragment } from '@web/federation/gql/graphql'
import { useErrorToast } from '@web/hooks/useErrorToast'
import { useNavigation } from '@web/hooks/useNavigation'
import links from '@web/libs/constants/links'
import { BookingNotificationSectionQuery } from '@web/pages/v5/home/BookingNotificationSection/query'
import { Nullish } from '@web/types'
import UIBookingNotificationSection from '@web/ui/pages/home/components/Sections/BookingNotificationSection'

const BookingNotificationSection = ({ user }: { user: Nullish<MyMe_UserFragment> }) => {
  const { data, error } = useQuery(BookingNotificationSectionQuery, { skip: !user })
  useErrorToast(error)
  const navigation = useNavigation()

  // 미로그인 상태시 bookingNotificationsCount 가 0 으로 오므로 로그인 플로우 대응 필요 없음
  const onClick = () => navigation.push({ url: links.BOOKING_NOTIFICATIONS })
  if (!data?.bookingNotificationsCount) return null

  return (
    <UIBookingNotificationSection
      count={data.bookingNotificationsCount}
      onClick={onClick}
      clickCode="myvacancyalert.detail"
    />
  )
}

export default BookingNotificationSection
